import React, {Fragment} from "react";
import BasicSelect from "./BasicSelect";
import useRolesFetch from "../views/Proactive/Utilities/hooks/useRolesFetch";

export default function RoleSelect({ name, label, placeholder, defaultValue, handleChange, input, meta }) {
    const {roles} = useRolesFetch();

    return(
        <Fragment>
            <BasicSelect
                name={name}
                label={label}
                placeholder={placeholder}
                options={roles}
                onChange={handleChange}
                input={input}
                defaultValue={defaultValue}
                meta={meta} />
        </Fragment>
    )
}
